import type {Snapshot} from '@platform/contracts/x';

// ADR-020: participation belongs to this Tombala draw, never to a favorite,
// draft selection, future purchase or the separate Roulette90 application.
export const hasParticipation=(draw:Snapshot)=>draw.tombala.ownTotalMinor>0||draw.tombala.refundedMinor>0||draw.tombala.ownPayoutMinor>0||draw.cards.some(c=>c.ownMinor>0)||draw.awards.some(a=>a.ownMinor>0);
export const isFinished=(draw:Snapshot)=>['Completed','Cancelled'].includes(draw.tombala.status)||['Completed','Cancelled'].includes(draw.status);
export const isCancelled=(draw:Snapshot)=>draw.tombala.status==='Cancelled'||draw.status==='Cancelled';
export const canBuy=(draw:Snapshot)=>draw.status==='SalesOpen'&&draw.tombala.status==='SalesOpen';
// Preparation only presents the starting draw. A future sale is available
// once the current draw is live; pending receipts keep their original identity.
export const canBuyFromRoom=(draw:Snapshot,current:Snapshot)=>canBuy(draw)&&(draw.drawId===current.drawId||current.status==='Live'||isFinished(current));
export function nextDraw(view:Snapshot,current:Snapshot){
 return [current,current.upcoming].find((draw):draw is Snapshot=>!!draw&&draw.drawId!==view.drawId&&!isFinished(draw))??null;
}
export function roomPhase(draw:Snapshot){
 if(isCancelled(draw))return 'cancelled';
 if(isFinished(draw))return !hasParticipation(draw)?'waiting-next':draw.tombala.ownPayoutMinor>0?'won':'lost';
 if(canBuy(draw))return hasParticipation(draw)?'sales-owned':'sales-empty';
 if(draw.status==='Preparing')return 'preparing';
 return hasParticipation(draw)?'playing':'watching';
}
